import {Component, OnDestroy, OnInit} from '@angular/core';
import {SurveyService} from "../../services/survey/survey.service";
import {NgClass, NgFor, NgIf} from "@angular/common";
import {Answer} from "../../models/answer.model";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {InfoModalComponent} from "../../components/modals/info-modal/info-modal.component";
import {AuthService} from "../../services/auth/auth.service";
import {Subscription} from "rxjs";
import {SignupModalComponent} from "../../components/modals/signup-modal/signup-modal.component";
import {AnswersDetailsComponent} from "../../components/answers/answers-details/answers-details.component";
import {
  AnswersAssociationsComponent
} from "../../components/answers/answers-associations/answers-associations.component";
import {AnswersAssistancesComponent} from "../../components/answers/answers-assistances/answers-assistances.component";
import {AnswersCompanyComponent} from "../../components/answers/answers-company/answers-company.component";
import {AnswersCustomersComponent} from "../../components/answers/answers-customers/answers-customers.component";
import {AnswersProComponent} from "../../components/answers/answers-pro/answers-pro.component";
import {AnswersPartnersComponent} from "../../components/answers/answers-partners/answers-partners.component";
import {AnswersSummaryComponent} from "../../components/answers/answers-summary/answers-summary.component";

@Component({
  selector: 'app-answers',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgClass,
    AnswersDetailsComponent,
    AnswersAssociationsComponent,
    AnswersAssistancesComponent,
    AnswersCompanyComponent,
    AnswersCustomersComponent,
    AnswersProComponent,
    AnswersPartnersComponent,
    AnswersSummaryComponent
  ],
  templateUrl: './answers.component.html',
  styleUrl: './answers.component.scss'
})
export class AnswersComponent implements OnInit, OnDestroy {

  error: boolean = false;
  answers?: Array<any>;
  associations?: Array<any>;
  assistances?: Array<any>;
  companies?: Array<any>;
  employers?: Array<any>;
  lawyers?: Array<any>;
  doctors?: Array<any>;
  psys?: Array<any>;
  cities?: Array<any>;
  customers?: Array<any>;
  banks?: Array<any>;
  thresholds?: any;
  thresholdOpened: any | null;
  level?: number;
  isAdo?: boolean = false;
  login?: string | null = null;
  display: string = 'SUMMARY';

  loginSubscription!: Subscription;

  modalRef!: BsModalRef;

  constructor(
    private surveySrv: SurveyService,
    private modalService: BsModalService,
    private authSrv: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.setLogin();
    await this.setSurvey();

    this.loginSubscription = this.authSrv.signInEvent.subscribe(async (status: boolean) => {
      this.setLogin();
      await this.setSurvey();
    });
  }

  async setSurvey() {
    let success = false;
    await this.surveySrv.getSurvey().subscribe(
      (data) => {
        this.answers = data.answers;
        this.level = data.level;
        this.thresholds = data.threshOlds;
        this.associations = data.associations;
        this.assistances = data.assistances;
        this.companies = data.companies;
        this.employers = data.employers;
        this.isAdo = data.isAdo;
        this.lawyers = data.lawyers;
        this.doctors = data.doctors;
        this.psys = data.psys;
        this.cities = data.cities;
        this.customers = data.customers;
        this.banks = data.banks;
        success = true;
      },
      (error) => {
        this.error = true;
      },
      () => {
        if (!success)
        {
          this.error = true;
        }
      }
    );
  }

  setLogin() {
    this.login = this.authSrv.getLogin();
  }

  ngOnDestroy(): void {
    this.loginSubscription.unsubscribe();
  }

  showLogin(): void {
    const modalOptions: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        message: 'Il te suffit de retenir ton mot de passe et le login suivant : <span class="fw-bolder text-primary">' + this.authSrv.getLogin() + '</span>.',
        title: 'Ton compte anonyme a bien été créé !'
      }
    };
    this.modalRef = this.modalService.show(InfoModalComponent, modalOptions);
  }

  private scrollToElement(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setDiplay(display: string): void {
    this.display = display;
    this.scrollToElement('details');
  }
}
